import Link from 'next/link';
import { Description, Dialog, DialogPanel, DialogTitle, DialogBackdrop, Button } from '@headlessui/react'

export const ChangeDashboardViewModal = ({isOpen, onClose, page}) =>  (
  <Dialog open={isOpen} onClose={onClose}>
    <DialogBackdrop className="fixed inset-0 bg-black/30 z-[1000]"/>
    <div className="fixed inset-0 flex w-screen items-center justify-center p-4 z-[1001]">
      <DialogPanel className="max-w-lg bg-white p-4 rounded-lg">
        <DialogTitle className="font-bold text-lg text-brand-text">Switch to User view</DialogTitle>
        <Description className='text-brand-text mb-4'>Are you sure you want to switch to User view?</Description>
        <p>
          User view is where you can manage your personal therapy and supervision. You will only find details
          relating to your professional therapy practice under <b>Therapist view</b>
        </p>
        <div className="flex flex-col sm:flex-row gap-2 mt-4">
          <Button
            className='px-4 w-full flex-nowrap rounded-full py-2 bg-brand text-white font-bold hover:bg-white hover:text-brand transition'
            onClick={onClose}>
            Stay on Therapist view
          </Button>
          <Link href={`/accounts/user-account/dashboard${page}`} className='w-full'>
            <Button
              className='w-full rounded-full px-4 py-2 bg-brand text-white font-bold hover:bg-white hover:text-brand transition'
            >
              Go to User view
            </Button>
          </Link>
        </div>
      </DialogPanel>
    </div>
  </Dialog>
);
